// src/demo/annualReviewDemoTranscript.js

import { MODAL_TYPES } from './constants/DemoModalTypes';

export const DEMO_TRANSCRIPT = [
  // 0 - Initial call confirmation
  {
    time: "00:00",
    speaker: "System",
    text: "[Call Initiated – recording started]"
  },
  // 1 - First tool introduction
  {
    time: "00:10",
    speaker: "Advisor",
    text: "Good morning, Thomas. It's been a little while since we last caught up — I appreciate you both taking the time today. How have things been with you?",
    action: { type: 'TRANSCRIPTION_INTRODUCTION' }
  },
  // 2
  {
    time: "00:19",
    speaker: "Thomas",
    text: "Good morning! It's been quite a year, but no complaints at all. And we appreciate you making the time for us. How are things on your end — keeping busy?"
  },
  // 3
  {
    time: "00:28",
    speaker: "Advisor",
    text: "Definitely busy, especially this time of year — but busy is good. Is Mary there with us?"
  },
  // 4
  {
    time: "00:32",
    speaker: "Mary",
    text: "Yes, I'm here!"
  },
  // 5
  {
    time: "00:34",
    speaker: "Advisor",
    text: "Hey Mary, how are you doing? How is retirement treating you so far?"
  },
  // 6
  {
    time: "00:39",
    speaker: "Mary",
    text: "I'm doing well. Retirement has been great! And with some big changes on Thomas' end, I am hoping he can join me a little sooner than we initially thought."
  },
  // 7
  {
    time: "00:46",
    speaker: "Advisor",
    text: "I'm so glad to hear that. Thomas, fill me in!"
  },
  // 8 - Smart Navigation trigger
  {
    time: "00:50",
    speaker: "Thomas",
    text: "Yes, I was promoted recently. It came with some new stock options and changes to my benefits including a nice bonus, so we wanted to talk through how that might impact our overall financial strategy. But also hoping this allows me to consider retiring earlier than our original plan.",
    action: { type: 'SMART_NAVIGATION' }
  },
  // 9
  {
    time: "00:58",
    speaker: "Advisor",
    text: "That's fantastic news — congratulations! And I did see your attachment that I will want to review with you guys later in this call. These are exactly the types of life changes we want to reflect in your plan. I've already prepared a full review of your portfolio performance and wanted to discuss some risk alignment adjustments as well. My goal is that you leave this call even more confident about the road ahead to retirement."
  },
  // 10
  {
    time: "01:10",
    speaker: "Advisor",
    text: "But before we dive in — what else has been keeping you both busy? You had a trip to Switzerland right after we spoke last fall?"
  },
  // 11
  {
    time: "01:18",
    speaker: "Thomas",
    text: "Yes! It was incredible — some of the most beautiful scenery we've seen."
  },
  // 12
  {
    time: "01:23",
    speaker: "Advisor",
    text: "That sounds amazing. Did you visit Geneva?"
  },
  // 13
  {
    time: "01:26",
    speaker: "Mary",
    text: "We actually went to Zurich and then spent some time in Grindelwald in the Alps. We've heard great things about Geneva though — maybe next time!"
  },
  // 14
  {
    time: "01:32",
    speaker: "Advisor",
    text: "I love it. I'm glad to hear you had a great time. We should definitely build some travel planning into your retirement roadmap — lifestyle goals matter just as much as investment returns. And how's everything going health-wise?"
  },
  // 15
  {
    time: "01:38",
    speaker: "Mary",
    text: "All good on my end."
  },
  // 16
  {
    time: "01:40",
    speaker: "Thomas",
    text: "Same here — can't complain."
  },
  // 17
  {
    time: "01:44",
    speaker: "Advisor",
    text: "Great to hear. Well, let's jump in here then. We'll start with a review of your household income—first, cash flow, then the balance sheet, dive into portfolio performance and allocations, and wrap with year-end tax optimization goals. Anything else you want to make sure we hit today?"
  },
  // 18
  {
    time: "01:52",
    speaker: "Thomas",
    text: "I don't believe anything outside of what we mentioned already in the questionnaire."
  },
  // 19
  {
    time: "01:55",
    speaker: "Advisor",
    text: "Excellent. So—looking at your cash flow, having your banking integration gives us real-time accuracy. I can see that your household net inflow remains strong. The promotion boosted your monthly net cash position by around $2,300 post-tax. With Mary retired, that's opened up a lot of breathing room. You're well ahead of your six-month reserve target, which is great."
  },
  // 20
  {
    time: "07:00",
    speaker: "Advisor",
    text: "Okay, now that we've confirmed those numbers and there are no major changes expected before year-end, your gross projected household income for 2025 looks like $141,787.52. With that increase, we could evaluate retiring earlier than our original goal of age 65. I'll return to that when we go through the modeling, but—were you thinking about a specific target?"
  },
  // 21
  {
    time: "07:12",
    speaker: "Thomas",
    text: "Just a year earlier—maybe 64. Not sure how that affects Social Security or Medicare though."
  },
  // 22
  {
    time: "07:18",
    speaker: "Advisor",
    text: "Got it. I'll keep that in mind. Today I'll give you a high-level feasibility snapshot, then follow up with a detailed breakdown in your recap email. Let's pivot now to the balance sheet. On liabilities: the mortgage is still your only major long-term obligation, correct?"
  },
  // 23
  {
    time: "07:28",
    speaker: "Thomas",
    text: "Correct. No plans to move or take on new debt at this point, any additional expenses we feel we can rely on our excess income and assets if we really needed to."
  },
  // 24 - Open allocations
  {
    time: "07:35",
    speaker: "Advisor",
    text: "Smart. Predictability is valuable as you prepare for your own transition into retirement, and if you do need to rely on asset distribution at all we just want to make sure we do that as efficiently as possible, which is what I am here to help guide you with. Now — on to the positive side of the balance sheet and your assets...",
    action: { type: 'OPEN_ALLOCATIONS' }
  },
  // 25.1
  {
    time: "07:44",
    speaker: "Advisor",
    text: "Let's discuss your performance since we last spoke."
  },
  // 25.2
  {
    time: "13:25",
    speaker: "Advisor",
    text: "Last three months… strong turnaround in tech and growth positions.",
    action: { 
      type: MODAL_TYPES.SMART_FOCUS, 
      data: { 
        spotlightId: '[data-demo-target="portfolio-performance"]',
        message: "Let's examine your portfolio's performance trends. This chart shows how your investments have grown over time.",
        demoStep: 7,
        title: "🧠 Smart Focus: Performance",
        description: "Let's analyze the recent market performance of your portfolio.",
        toolIntroduction: true,
        buttonLabel: "Focus"
      }
    }
  },
  {
    time: "13:28",
    speaker: "Thomas",
    text: "Can you show me Apple's recent performance?",
    action: {
      type: MODAL_TYPES.SMART_FOCUS,
      data: {
        spotlightId: '[data-spotlight-target="holding-AAPL-row"]',
        message: "Here's your Apple holding—let's drill in on those numbers.",
        demoStep: 8,
        title: "🧠 Smart Focus: Holding Details",
        description: "Let's examine the details of your Apple position."
      }
    }
  },
  {
    time: "13:30",
    speaker: "Mary",
    text: "That's great to hear. I hadn't realized it had grown that much.",
    action: { type: 'RETURN_REVIEW' }
  },
  // 26
  {
    time: "13:34",
    speaker: "Advisor",
    text: "It's been a strong year—you've benefitted from disciplined allocation, dividend reinvestment, and reduced drawdowns. Given you aren't taking distributions yet, and with the addition of the RSUs, we have some flexibility to reassess your risk profile. Would you be open to re-evaluating your portfolio risk score?"
  },
  // 27
  {
    time: "13:45",
    speaker: "Thomas",
    text: "Sure—I think we feel good where we are, but no harm in reviewing."
  },
  // 28
  {
    time: "13:50",
    speaker: "Advisor",
    text: "We have two options: I can walk you through it now or send a link in your recap for you to complete later—whichever is easier."
  },
  // 29
  {
    time: "13:56",
    speaker: "Thomas",
    text: "Let's do it later—just send the link.",
    action: { type: 'TASK_CREATION' } 
  },
  // 30 - Stock options reminder
  {
    time: "14:00",
    speaker: "Advisor",
    text: "Now that I have brought it up, let's talk about those RSUs. I saw in the documents you uploaded that you've been granted 2,500 RSUs, vesting over four years starting in January 2026, fully vested by January 2030. Are there any additional grant details we should consider? And — do you have questions about how they'll affect your retirement timeline?",
    action: { type: 'SALES_REMINDER_STOCK_OPTIONS' }
  },
  // 31
  {
    time: "14:18",
    speaker: "Thomas",
    text: "Yes—I've never had RSUs before. What are the tax implications? And if I retire earlier, would I forfeit unvested shares?"
  },
  // 32
  {
    time: "14:30",
    speaker: "Advisor",
    text: "Great questions. RSUs are taxed as ordinary income when they vest—no buy-in. If Pfizer offers 'qualified retirement' treatment—often available if you're 55+ with 10 years of service—unvested shares might continue vesting post-retirement. We'll confirm the specifics. Tax-wise, income from vested shares is spread across 2026–2030 unless they continue vesting."
  },
  // 33
  {
    time: "19:00",
    speaker: "Advisor",
    text: "Glad we could get all of those questions reviewed, you are basically an expert on the matter now haha. I'll model the RSUs into your asset plan and send scenarios in your recap. I will also make sure that the updated Risk Tolerance Analysis reflects and includes these new assets in your balance sheet.",
    action: { type: 'SALES_REMINDER_PLANNING_GOALS' }
  },
  // 34
  {
    time: "19:16",
    speaker: "Advisor",
    text: "So to follow up on your other question about how this might impact retirement, and the possibility of joining Mary sooner, at age 64. This is a very high level view, so I don't want to give you a definitive answer right now, but preliminary modeling shows that retiring one year early reduces your financial health score from 94 to 91 — still well within safe territory, and a 95% confidence interval of retiring and maintaining your desired income through your respective life expectancies. Would you like to walk through your goals to confirm alignment, or discuss any other changes with life expectancy or future income goals?"
  },
  // 35
  {
    time: "19:54",
    speaker: "Thomas",
    text: "Not yet. More of a future consideration for now."
  },
  // 36
  {
    time: "20:04",
    speaker: "Advisor",
    text: "Okay I think that sounds like a good plan to me. Now one other thing I had a note to discuss from our previous conversation were some more uniquely tailored options that could serve as a good fit in your portfolios, especially with the recent changes to both your balance sheet and possible changes in your future retirement plans. One opportunity I'd like to introduce today is Private Equity fund opportunities, where an allocation I feel could fit your liquidity targets and tax strategy, while diversifying your overall exposure, and aim to improve that overall ROI regardless of if your risk tolerance changes at all when you complete that updated analysis after we wrap up here today.",
    action: { type: 'SALES_REMINDER_ALTERNATIVES' }
  },
  // 37
  {
    time: "20:48",
    speaker: "Mary",
    text: "That sounds worth reviewing."
  },
  // 38
  {
    time: "20:59",
    speaker: "Advisor",
    text: "I know I am throwing a lot at you today, but I'll at least introduce some concepts, walk through the structure, and touch on a few opportunities, and that way I can include scenario testing for potential rebalancing in the recap package. This will be dependent on the results and any changes we might see on that Risk Tolerance Assessment as well."
  },
  // 39
  {
    time: "25:45",
    speaker: "Advisor",
    text: "Now, to close with what we have been building up to throughout the call and let's walk through your year-end tax strategy.",
    action: {
      type: MODAL_TYPES.SMART_FOCUS,
      data: {
        demoStep: 10,
        spotlightId: '#tax-analysis-section',
        message: "Let's examine your tax situation. This section shows your tax brackets, deductions, and exemptions.",
        title: "🧠 Smart Focus: Tax Analysis",
        description: "Let's review your tax brackets, deductions, and exemptions to optimize your year-end strategy.",
        buttonLabel: "Focus",
        disableDismiss: true,
        waitForFocus: true
      }
    }
  },
  // 40
  {
    time: "29:00",
    speaker: "Advisor",
    text: "So to recap that, based on gains and tax loss harvest opportunities that we will handle in December to offset some gains on your Joint Non-Qualified Joint, we estimate you can convert up to $40,000 without exceeding your current bracket."
  },
  // 41
  {
    time: "29:10",
    speaker: "Thomas",
    text: "Sounds like a good plan."
  },
  // 42
  {
    time: "29:14",
    speaker: "Advisor",
    text: "This leaves a cushion of 10% in case we missed any income, but regardless you'll want to confirm with your CPA, but I'll include these details in the follow-up, and we still have plenty of time to get that all reviewed and confirmed. Are you still working with Ms. Sandra Dixon over at H&R Block? I know she was thinking about retiring soon."
  },
  // 43
  {
    time: "29:20",
    speaker: "Mary",
    text: "Yes we are still with Sandra, she might have a couple years left, but we know you have mentioned being able to set us up with someone in your network when the time comes, so we will keep that in mind.",
    action: { type: 'ESTATE_PLANNING' } 
  },
  // 44
  {
    time: "29:25",
    speaker: "Advisor",
    text: "Excellent, unlike some of my clients I can tell you guys are always listening to me haha. Anything new with your estate or trust planning?",
    
  },
  // 45
  {
    time: "29:29",
    speaker: "Mary",
    text: "It helps that I have a whole folder of notes and documents from over the years haha. No changes there though — we still want to wait until Thomas retires. But we'd like to revisit that venture fund again soon."
  },
  // 46
  {
    time: "29:50",
    speaker: "Advisor",
    text: "Of course. On the estate side — I'd just add that we've built a very streamlined process with integrated trust planning that saves time and connects directly with your asset map. Earlier planning can reduce cost and optimize tax structure."
  },
  // 47 - Complete demo
  {
    time: "30:00",
    speaker: "Advisor",
    text: "Well, I think we've covered everything I had on my agenda for today. Let me know if you have any other questions or concerns before we wrap up.",
    action: { type: 'POST_MEETING_TASKS' }
  },
  // 48
  {
    time: "30:08",
    speaker: "Advisor",
    text: "Completely understood. Let's prioritize what matters now. I'll send a follow-up invite and detailed recap, and then we can focus on some of those longer term looking topics in a separate conversation."
  },
  // 49
  {
    time: "34:00",
    speaker: "Advisor",
    text: "Okay great I have you in my calendar for 3 weeks from now, you will each be receiving a calendar invite emailed from me shortly. I think that covers everything I wanted to on my end, is there anything else you want to discuss today before we wrap it up?"
  },
  // 50
  {
    time: "34:10",
    speaker: "Mary",
    text: "No, I think that covers it."
  },
  // 51
  {
    time: "34:15",
    speaker: "Thomas",
    text: "Agreed, this was very informative, and we look forward to reviewing your email, and following up on getting me out of here sooner!"
  },
  // 52
  {
    time: "34:20",
    speaker: "Advisor",
    text: "Likewise Thomas, and thanks to both of you again for the time — I'll include your next steps, RSU modeling, alternative strategy materials, and details about an estate planning session. Give me a couple days to pull this together. As always if you have any questions on it once you receive it let me know, and we will be talking again very soon! Take care guys!"
  },
  // 53
  {
    time: "34:28",
    speaker: "Thomas",
    text: "Take care!"
  },
  // 54
  {
    time: "34:30",
    speaker: "Mary",
    text: "Bye now!"
  },
  // 55
  {
    time: "34:32",
    speaker: "System",
    text: "[Call ended – recording stopped]",
    action: { type: 'END_DEMO' }
  }
];

export const DEMO_NOTES_SUMMARY = `Annual Financial Review with Thomas & Mary

📰 Personal & Life Updates:
- Thomas promoted to Senior Director of Engineering
- Significant RSU grant received
- Considering early retirement at 64
- Recent travel to Switzerland
- Both in good health

💵 Income & Cash Flow:
- 2025 Income: $141,787.52
- Monthly Net Gain: +$2,300
- Strong cash reserves maintained

🏦 Balance Sheet:
- Mortgage remains only liability
- Strong asset growth trend
- 2,500 RSUs (2026-2030 vesting)

⚖️ Risk Assessment:
- Conservative-moderate profile
- Reassessment pending via questionnaire

📈 Retirement Planning:
- Early retirement (64) feasible
- 95% confidence in sustainability
- Score: 91/94 on projections

💼 Investment Strategy:
- PE funds proposed
- Pending risk assessment results

🧾 Tax Planning:
- $40K Roth conversion proposed
- 10% buffer included
- CPA confirmation needed

📜 Estate Planning:
- Review pending retirement decision
- Streamlined service available`;

export const DEMO_NOTES_UPDATES = [
  { id: "u1", icon: "🎯", label: "Career Update", value: "Promotion to Senior Director of Engineering with RSU grant" },
  { id: "u2", icon: "💰", label: "Compensation", value: "2,500 RSUs vesting 2026-2030" },
  { id: "u3", icon: "🏦", label: "Cash Flow", value: "Monthly Net: +$2,300" },
  { id: "u4", icon: "🎯", label: "Retirement", value: "Considering early retirement at 64" }
];

export const DEMO_NOTES_TASKS = [
  { id: "t1", text: "Send risk assessment questionnaire link", done: false },
  { id: "t2", text: "Schedule CPA consultation for Roth conversion strategy", done: false },
  { id: "t3", text: "Prepare PE fund analysis report", done: false },
  { id: "t4", text: "Update retirement projections with new RSU data", done: false }
];
